<template>
	<div>
		<v-button theme="black" size="md" @click="logIn">
			{{ t("login") }}
		</v-button>
	</div>
</template>

<script lang="ts" setup>
import {useAuth} from "@pkg/shared/composables/use-auth";

defineProps<{
	fontColor?: string;
}>();

const {t} = useI18n();
const auth = useAuth();

async function logIn() {
	await auth.login(window.location.pathname);
}
</script>
